<template>
  <div class="dis">
    <div class="dis-tree">
      <span>数据字典</span>
      <div>
        <el-input clearable v-model="searchText" placeholder="请输入搜索名称">
        </el-input>
        <el-tree
          ref="tree"
          class="filter-tree"
          :node-key="id"
          :data="treeData"
          :props="defaultProps"
          default-expand-all
          highlight-current
          :expand-on-click-node="false"
          :filter-node-method="searchNode"
          @node-click="getNodeDetail">
        </el-tree>
      </div>
    </div>
    <div class="dis-detail">
      <el-form
        :model='dataForm'
        :rules='dataFormRules'
        ref='dataFormRef'
        label-width='70px'
        style="width: 800px;margin-top: 50px;"
      >
        <el-form-item style="text-align: left;">
          <el-button @click='toEdit' v-if="dataId != ''" :type='dataStatus == 1? "primary": ""'>编辑</el-button>
          <el-button @click='toAdd' :type='dataStatus == 2? "primary": ""'>新增</el-button>
          <el-button @click='toDel' v-if="dataId != ''" :type='dataStatus == 3? "primary": ""'>删除</el-button>
        </el-form-item>
        <el-form-item label='编码'>
          <el-input v-model='dataForm.code' prop='code' :disabled='dataStatus != 2'></el-input>
        </el-form-item>
        <el-form-item label='值'>
          <el-input v-model='dataForm.value' prop='value' :disabled='dataStatus == 0 || dataStatus == 3'></el-input>
        </el-form-item>
        <el-form-item label='父级编码'>
          <el-input v-model='dataForm.parentCode' prop='parentCode' :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label='层级'>
          <el-input v-model='dataForm.type' prop='type' :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click='reset()' v-if="dataStatus != 0">取 消</el-button>
          <el-button type='primary' @click='submit' v-if="dataStatus != 0">保 存</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
// import qs from 'qs'
export default {
  data () {
    return {
      searchText: '',
      // 树
      treeData: [{
        id: '',
        code: '',
        value: '',
        parentId: '',
        parentCode: '',
        type: '',
        status: ''
      }],
      // 数据列表
      dataForm: {
        id: 0,
        code: '',
        value: '',
        parentId: 0,
        parentCode: '',
        type: 0,
        status: 0
      },
      // 查询信息
      defaultProps: {
        children: 'childList',
        id: 'id',
        label: 'code'
      },
      // 表单验证
      dataFormRules: {
        code: [
          { required: true, message: '请输入显示文本', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: '数据名的长度在3-15个字符之间',
            trigger: 'blur'
          }
        ],
        value: [
          { required: false, message: '请输入跳转地址', trigger: 'blur' },
          {
            min: 6,
            message: '跳转地址的长度在6-15个字符之间',
            trigger: 'blur'
          }
        ]
      },
      dataId: 0,
      dataStatus: 0
    }
  },
  created () {
    this.getDataList()
  },
  watch: {
    searchText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    async getDataList () {
      const { data: res } = await this.$http.post('/dictionary/tree', {})
      if (res.code !== 1) {
        return this.$message.error('获取数据列表失败！')
      }
      this.treeData = res.body
      console.info('getDataList.treeData = ' + this.treeData)
    },
    // 监听对话框的关闭
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // 提交表单
    submit () {
      var status = this.dataStatus
      console.info('submit.dataStatus = ' + status)
      if (status === 1) {
        this.editData()
      } else if (status === 2) {
        this.addData()
      } else if (status === 3) {
        this.removeById()
      }
    },
    // 点击按钮添加数据
    addData () {
      this.$refs.dataFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加数据的网络请求
        const { data: res } = await this.$http.post(
          '/dictionary/insert',
          {
            code: this.dataForm.code,
            value: this.dataForm.value,
            parentId: this.dataForm.parentId,
            parentCode: this.dataForm.parentCode,
            type: this.dataForm.type
          }
        )
        if (res == null) {
          this.$message.error('添加数据失败！')
        }
        this.$message.success('添加数据成功！')
        // 重新获取数据列表
        this.getDataList()
        this.dataStatus = 0
      })
    },
    // 修改数据信息并提交
    editData () {
      this.$refs.dataFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改信息的数据请求
        const { data: res } = await this.$http.post(
          '/dictionary/update',
          {
            code: this.dataForm.code,
            value: this.dataForm.value,
            id: this.dataForm.id
          }
        )
        if (res == null) {
          return this.$message.error('更新数据信息失败！')
        }
        // 提示修改成功
        this.$message.success('更新数据信息成功！')
        // 刷新数据列表
        this.getDataList()
        this.dataStatus = 0
      })
    },
    // 根据id删除数据
    async removeById () {
      // 弹窗询问数据是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果数据确认删除，则返回值为字符串confirm
      // 如果数据了取消了删除，则返回值为字符串 cancel
      // 所以可以考返回值判断数据是否删除
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post(
        '/dictionary/delete',
        { id: this.dataId }
      )
      console.info('removeById.res = ' + res)
      if (res === null) {
        return this.$message.error('删除数据失败')
      }
      if (res.code !== 1) {
        return this.$message.error(res.message)
      }
      this.$message.success('删除数据成功')
      this.getDataList()
      this.dataStatus = 0
      this.dataId = 0
    },
    getNodeDetail (node, e) {
      this.dataId = node.id
      this.getDataDetail()
      this.dataStatus = 0
    },
    async getDataDetail () {
      const { data: res } = await this.$http.post('/dictionary/detail', {id: this.dataId})
      this.dataForm = res.body
    },
    searchNode (value, data) {
      if (!value) return true
      return data.code.indexOf(value) !== -1
    },
    // 重置表单内容
    reset () {
      if (this.dataId !== null) {
        this.getDataDetail()
      }
      this.dataStatus = 0
    },
    // 重置表单内容
    toEdit () {
      this.dataStatus = 1
    },
    // 重置表单内容
    toAdd () {
      this.dataStatus = 2
      const dataDetails = this.dataForm
      this.dataForm = {
        id: '',
        code: '',
        value: '',
        parentId: this.dataId,
        parentCode: this.dataId === 0 ? '' : dataDetails.parentCode + ',' + dataDetails.code,
        type: dataDetails.type + 1
      }
    },
    // 重置表单内容
    toDel () {
      this.dataStatus = 3
    }
  }
}
</script>

<style scoped>
.dis-tree {
  width: 30%;
  height: 100%;
  float: left;
  margin-left: 20px;
}
.dis-tree span {
  line-height: 50px;
}
.dis-detail{
  width: 65%;
  height: 100%;
  float: right;
}
.dis-detail el-form el-form-item{
  width: 500px;
}
.el-tree {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/dictionary.vue